/** Ids pinned by the sales.sales_order_shortfall_resolution seed rows. */
export var SalesOrderShortfallResolution;
(function (SalesOrderShortfallResolution) {
    SalesOrderShortfallResolution[SalesOrderShortfallResolution["VOID"] = 1] = "VOID";
    SalesOrderShortfallResolution[SalesOrderShortfallResolution["BACKORDER"] = 2] = "BACKORDER";
})(SalesOrderShortfallResolution || (SalesOrderShortfallResolution = {}));
//# sourceMappingURL=sales-order-shortfall-resolution.js.map